import { KEY_ESC } from "./_global-variables.js";
import { debounce } from "./vendor/debounce.js";
import { toggleMenuVisibility, toggleVenueNavVisibility } from "./menu.js";

/*
* Set up all global event handlers here
*/

(function() {
    window.addEventListener("keyup", function(e) {
        if (KEY_ESC.includes(e.key)) {
            handleEscapeKey();
        }
    });

    window.addEventListener("resize", debounce(function(e) {
        handlePageResize();
    }, 50));

    document.addEventListener("scroll", debounce(function(e) {
        handlePageScroll();
    }, 5));

    /*
    * Function invoked when the page is scrolled
    */
    function handlePageScroll() {
        
    }

    /*
    * Function invoked when the page is resized
    */
    function handlePageResize() {

    }

    /*
    * Function invoked when the escape key is pressed
    */
    function handleEscapeKey() {
        toggleMenuVisibility(false);
        toggleVenueNavVisibility(false);
    }
}());
